import app from "@@assets/scripts/common";
const { _relativePath } = app;

/**
 * events data
 * イベント一覧データ
 * @props {string} date 日時（YYYY-MM-DD\THH:mm）
 * @props {string} title タイトル
 * @props {string} [href] 詳細ページURL
 */
export default [
	// ** 2020-12 **
	...[
		{
			date: "2020-12-01T00:00",
			title: "代表のこれまでのあゆみ",
			src: `${_relativePath}/contents/topics/2020/12-001/main.jpg`,
			href: `${_relativePath}/contents/topics/2020/12-001/`,
		},
		{
			date: "2020-12-01T00:00",
			title: "ホームページをリニューアルしました！",
			src: `${_relativePath}/contents/topics/2020/12-002/main.png`,
			href: `${_relativePath}/contents/topics/2020/12-002/`,
		},
		{
			date: "2020-12-25T00:00",
			title: "12月のトピックス",
			src: `${_relativePath}/contents/topics/2020/12-003/main.jpg`,
			href: `${_relativePath}/contents/topics/2020/12-003/`,
		},
	],
	// ** 2021-02 **
	...[
		{
			date: "2021-02-04T00:00",
			title: "1月のトピックス",
			src: `${_relativePath}/contents/topics/2021/02-001/main.png`,
			href: `${_relativePath}/contents/topics/2021/02-001/`,
		},
	],
	// ** 2021-03 **
	...[
		{
			date: "2021-03-10T00:00",
			title: "2月のトピックス",
			src: `${_relativePath}/contents/topics/2021/03-001/main.png`,
			href: `${_relativePath}/contents/topics/2021/03-001/`,
		},
	],
	// ** 2021-04 **
	...[
		{
			date: "2021-04-14T00:00",
			title: "3月のトピックス",
			src: `${_relativePath}/contents/topics/2021/04-001/main.png`,
			href: `${_relativePath}/contents/topics/2021/04-001/`,
		},
	],
	// ** 2021-05 **
	...[
		{
			date: "2021-05-11T00:00",
			title: "4月のトピックス",
			src: `${_relativePath}/contents/topics/2021/05-001/main.jpg`,
			href: `${_relativePath}/contents/topics/2021/05-001/`,
		},
	],
	// ** 2021-06 **
	...[
		{
			date: "2021-06-15T00:00",
			title: "5月のトピックス",
			src: `${_relativePath}/contents/topics/2021/06-001/main.jpg`,
			href: `${_relativePath}/contents/topics/2021/06-001/`,
		},
	],
	// ** 2021-07 **
	...[
		{
			date: "2021-07-12T00:00",
			title: "6月のトピックス",
			src: `${_relativePath}/contents/topics/2021/07-001/main.jpg`,
			href: `${_relativePath}/contents/topics/2021/07-001/`,
		},
	],
	// ** 2021-08 **
	...[
		{
			date: "2021-08-04T00:00",
			title: "7月のトピックス",
			src: `${_relativePath}/contents/topics/2021/08-001/main.png`,
			href: `${_relativePath}/contents/topics/2021/08-001/`,
		},
	],
	// ** 2021-09 **
	...[
		{
			date: "2021-09-08T00:00",
			title: "8月のトピックス",
			src: `${_relativePath}/contents/topics/2021/09-001/main.png`,
			href: `${_relativePath}/contents/topics/2021/09-001/`,
		},
	],
	// ** 2021-10 **
	...[
		{
			date: "2021-10-07T00:00",
			title: "9月のトピックス",
			src: `${_relativePath}/contents/topics/2021/10-001/main.jpg`,
			href: `${_relativePath}/contents/topics/2021/10-001/`,
		},
	],
	// ** 2021-11 **
	...[
		{
			date: "2021-11-15T00:00",
			title: "10月のトピックス",
			src: `${_relativePath}/contents/topics/2021/11-001/main.jpg`,
			href: `${_relativePath}/contents/topics/2021/11-001/`,
		},
	],
	// ** 2021-12 **
	...[
		{
			date: "2021-12-07T00:00",
			title: "11月のトピックス",
			src: `${_relativePath}/contents/topics/2021/12-001/main.jpg`,
			href: `${_relativePath}/contents/topics/2021/12-001/`,
		},
	],
	// ** 2022-01 **
	...[
		{
			date: "2022-01-13T00:00",
			title: "12月のトピックス",
			src: `${_relativePath}/contents/topics/2022/01-001/main.jpg`,
			href: `${_relativePath}/contents/topics/2022/01-001/`,
		},
	],
	// ** 2022-02 **
	...[
		{
			date: "2022-02-01T00:00",
			title: "1月のトピックス",
			src: `${_relativePath}/contents/topics/2022/02-001/main.jpg`,
			href: `${_relativePath}/contents/topics/2022/02-001/`,
		},
	],
	// ** 2022-03 **
	...[
		{
			date: "2022-03-10T00:00",
			title: "2月のトピックス",
			src: `${_relativePath}/contents/topics/2022/03-001/main.jpg`,
			href: `${_relativePath}/contents/topics/2022/03-001/`,
		},
	],
	// ** 2022-04 **
	...[
		{
			date: "2022-04-07T00:00",
			title: "3月のトピックス",
			src: `${_relativePath}/contents/topics/2022/04-001/main.jpg`,
			href: `${_relativePath}/contents/topics/2022/04-001/`,
		},
	],
	// ** 2022-05 **
	...[
		{
			date: "2022-05-17T00:00",
			title: "4月のトピックス",
			src: `${_relativePath}/contents/topics/2022/05-001/main.jpg`,
			href: `${_relativePath}/contents/topics/2022/05-001/`,
		},
	],
	// ** 2022-06 **
	...[
		{
			date: "2022-06-03T00:00",
			title: "入居一時金を撤廃しました",
			src: `${_relativePath}/contents/topics/2022/06-001/main.jpg`,
			href: `${_relativePath}/contents/topics/2022/06-001/`,
		},
	],
	// ** 2022-07 **
	...[
		{
			date: "2022-07-26T00:00",
			title: "6月のトピックス",
			src: `${_relativePath}/contents/topics/2022/07-001/main.jpg`,
			href: `${_relativePath}/contents/topics/2022/07-001/`,
		},
	],
	// ** 2022-08 **
	...[
		{
			date: "2022-08-04T00:00",
			title: "7月のトピックス",
			src: `${_relativePath}/contents/topics/2022/08-001/main.png`,
			href: `${_relativePath}/contents/topics/2022/08-001/`,
		},
	],
	// ** 2022-09 **
	...[
		{
			date: "2022-09-27T00:00",
			title: "8月のトピックス",
			src: `${_relativePath}/contents/topics/2022/09-001/main.png`,
			href: `${_relativePath}/contents/topics/2022/09-001/`,
		},
	],
	// ** 2022-10 **
	...[
		{
			date: "2022-10-25T00:00",
			title: "9月のトピックス",
			src: `${_relativePath}/contents/topics/2022/10-001/main.png`,
			href: `${_relativePath}/contents/topics/2022/10-001/`,
		},
	],
	// ** 2022-11 **
	...[
		{
			date: "2022-11-28T00:00",
			title: "10月のトピックス",
			src: `${_relativePath}/contents/topics/2022/11-001/main.jpg`,
			href: `${_relativePath}/contents/topics/2022/11-001/`,
		},
	],
	// ** 2022-12 **
	...[
		{
			date: "2022-12-23T00:00",
			title: "11月のトピックス",
			src: `${_relativePath}/contents/topics/2022/12-001/main.jpg`,
			href: `${_relativePath}/contents/topics/2022/12-001/`,
		},
	],
	// ** 2023-01 **
	...[
		{
			date: "2023-01-19T00:00",
			title: "12月のトピックス",
			src: `${_relativePath}/contents/topics/2023/01-001/main.png`,
			href: `${_relativePath}/contents/topics/2023/01-001/`,
		},
	],
	// ** 2023-02 **
	...[
		{
			date: "2023-02-20T00:00",
			title: "1月のトピックス",
			src: `${_relativePath}/contents/topics/2023/02-001/main.png`,
			href: `${_relativePath}/contents/topics/2023/02-001/`,
		},
	],
	// ** 2023-03 **
	...[
		{
			date: "2023-03-20T00:00",
			title: "2月のトピックス",
			src: `${_relativePath}/contents/topics/2023/03-001/main.png`,
			href: `${_relativePath}/contents/topics/2023/03-001/`,
		},
	],
	// ** 2023-04 **
	...[
		{
			date: "2023-04-19T00:00",
			title: "3月のトピックス",
			src: `${_relativePath}/contents/topics/2023/04-001/main.png`,
			href: `${_relativePath}/contents/topics/2023/04-001/`,
		},
	],
	// ** 2023-05 **
	...[
		{
			date: "2023-05-16T00:00",
			title: "4月のトピックス",
			src: `${_relativePath}/contents/topics/2023/05-001/main.png`,
			href: `${_relativePath}/contents/topics/2023/05-001/`,
		},
	],
	// ** 2023-06 **
	...[
		{
			date: "2023-06-12T00:00",
			title: "5月のトピックス",
			src: `${_relativePath}/contents/topics/2023/06-001/main.jpg`,
			href: `${_relativePath}/contents/topics/2023/06-001/`,
		},
	],
	// ** 2023-07 **
	...[
		{
			date: "2023-07-28T00:00",
			title: "6月のトピックス",
			src: `${_relativePath}/contents/topics/2023/07-001/main.jpg`,
			href: `${_relativePath}/contents/topics/2023/07-001/`,
		},
	],
	// ** 2023-08 **
	...[
		{
			date: "2023-08-18T00:00",
			title: "7月のトピックス",
			src: `${_relativePath}/contents/topics/2023/08-001/main.png`,
			href: `${_relativePath}/contents/topics/2023/08-001/`,
		},
	],
	// ** 2023-09 **
	...[
		{
			date: "2023-09-21T00:00",
			title: "8月のトピックス",
			src: `${_relativePath}/contents/topics/2023/09-001/main.png`,
			href: `${_relativePath}/contents/topics/2023/09-001/`,
		},
	],
	// ** 2023-10 **
	...[
		{
			date: "2023-10-12T00:00",
			title: "9月のトピックス",
			src: `${_relativePath}/contents/topics/2023/10-001/main.png`,
			href: `${_relativePath}/contents/topics/2023/10-001/`,
		},
	],
	// ** 2023-12 **
	...[
		{
			date: "2023-12-04T00:00",
			title: "10月のトピックス",
			src: `${_relativePath}/contents/topics/2023/12-001/main.png`,
			href: `${_relativePath}/contents/topics/2023/12-001/`,
		},
	],
	// ** 2023-12 **
	...[
		{
			date: "2023-12-25T00:00",
			title: "11月のトピックス",
			src: `${_relativePath}/contents/topics/2023/12-002/main.png`,
			href: `${_relativePath}/contents/topics/2023/12-002/`,
		},
	],
	// ** 2024-01 **
	...[
		{
			date: "2024-01-23T00:00",
			title: "12月のトピックス",
			src: `${_relativePath}/contents/topics/2024/01-001/main.png`,
			href: `${_relativePath}/contents/topics/2024/01-001/`,
		},
	],
	// ** 2024-02 **
	...[
		{
			date: "2024-02-15T00:00",
			title: "1月のトピックス",
			src: `${_relativePath}/contents/topics/2024/02-001/main.png`,
			href: `${_relativePath}/contents/topics/2024/02-001/`,
		},
	],
	// ** 2024-03 **
	...[
		{
			date: "2024-03-19T00:00",
			title: "2月のトピックス",
			src: `${_relativePath}/contents/topics/2024/03-001/main.png`,
			href: `${_relativePath}/contents/topics/2024/03-001/`,
		},
	],
	// ** 2024-04 **
	...[
		{
			date: "2024-04-17T00:00",
			title: "3月のトピックス",
			src: `${_relativePath}/contents/topics/2024/04-001/main.png`,
			href: `${_relativePath}/contents/topics/2024/04-001/`,
		},
	],
	// ** 2024-05 **
	...[
		{
			date: "2024-05-22T00:00",
			title: "4月のトピックス",
			src: `${_relativePath}/contents/topics/2024/05-001/main.png`,
			href: `${_relativePath}/contents/topics/2024/05-001/`,
		},
	],
	// ** 2024-06 **
	...[
		{
			date: "2024-06-17T00:00",
			title: "5月のトピックス",
			src: `${_relativePath}/contents/topics/2024/06-001/main.png`,
			href: `${_relativePath}/contents/topics/2024/06-001/`,
		},
	],
	// ** 2024-07 **
	...[
		{
			date: "2024-07-12T00:00",
			title: "6月のトピックス",
			src: `${_relativePath}/contents/topics/2024/07-001/main.png`,
			href: `${_relativePath}/contents/topics/2024/07-001/`,
		},
	],
	// ** 2024-08 **
	...[
		{
			date: "2024-08-20T00:00",
			title: "7月のトピックス",
			src: `${_relativePath}/contents/topics/2024/08-001/main.png`,
			href: `${_relativePath}/contents/topics/2024/08-001/`,
		},
	],
	// ** 2024-09 **
	...[
		{
			date: "2024-09-19T00:00",
			title: "8月のトピックス",
			src: `${_relativePath}/contents/topics/2024/09-001/main.png`,
			href: `${_relativePath}/contents/topics/2024/09-001/`,
		},
	],
	// ** 2024-10 **
	...[
		{
			date: "2024-10-30T00:00",
			title: "9月のトピックス",
			src: `${_relativePath}/contents/topics/2024/10-001/main.png`,
			href: `${_relativePath}/contents/topics/2024/10-001/`,
		},
	],
	// ** 2024-11 **
	...[
		{
			date: "2024-11-19T00:00",
			title: "10月のトピックス",
			src: `${_relativePath}/contents/topics/2024/11-001/main.png`,
			href: `${_relativePath}/contents/topics/2024/11-001/`,
		},
	],
	// ** 2024-12 **
	...[
		{
			date: "2024-12-20T00:00",
			title: "11月のトピックス",
			src: `${_relativePath}/contents/topics/2024/12-001/main.png`,
			href: `${_relativePath}/contents/topics/2024/12-001/`,
		},
	],
	// ** 2025-01 **
	...[
		{
			date: "2025-01-17T00:00",
			title: "12月のトピックス",
			src: `${_relativePath}/contents/topics/2025/01-001/main.png`,
			href: `${_relativePath}/contents/topics/2025/01-001/`,
		},
	],
	// ** 2025-02 **
	...[
		{
			date: "2025-02-17T00:00",
			title: "1月のトピックス",
			src: `${_relativePath}/contents/topics/2025/02-001/main.png`,
			href: `${_relativePath}/contents/topics/2025/02-001/`,
		},
	],
	// ** 2025-03 **
	...[
		{
			date: "2025-03-26T00:00",
			title: "2月のトピックス",
			src: `${_relativePath}/contents/topics/2025/03-001/main.png`,
			href: `${_relativePath}/contents/topics/2025/03-001/`,
		},
	],
	// ** 2025-04 **
	...[
		{
			date: "2025-04-25T00:00",
			title: "3月のトピックス",
			src: `${_relativePath}/contents/topics/2025/04-001/main.png`,
			href: `${_relativePath}/contents/topics/2025/04-001/`,
		},
	],
	// ** 2025-05 **
	...[
		{
			date: "2025-05-28T00:00",
			title: "4月のトピックス",
			src: `${_relativePath}/contents/topics/2025/05-001/main.png`,
			href: `${_relativePath}/contents/topics/2025/05-001/`,
		},
	],
	// ** 2025-06 **
	...[
		{
			date: "2025-06-30T00:00",
			title: "5月のトピックス",
			src: `${_relativePath}/contents/topics/2025/06-001/main.png`,
			href: `${_relativePath}/contents/topics/2025/06-001/`,
		},
	],
];
